module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)1.25abf0a1.jpg";